import React, { useState } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";

// Hướng dẫn sử dụng LearningHub cho Admin / Giáo viên (end user).
// Ảnh minh họa trong public/huong-dan-learning-admin/.

const chucNang = [
  { group: "Ngân hàng câu hỏi", link: "/learninghub_cauhoi", desc: "Tạo, sửa, xoá câu hỏi theo 5 dạng; phân loại theo danh mục." },
  { group: "Bài kiểm tra / Bài tập", link: "/learninghub_dethi", desc: "Tạo đề, thêm câu hỏi từ ngân hàng, gán điểm, chọn người tham gia." },
  { group: "Bài làm của thí sinh", link: "/learninghub_bailam", desc: "Xem danh sách bài nộp, chấm điểm câu tự luận, xem kết quả." },
];

const loaiCauHoi = [
  { code: "single", name: "Trắc nghiệm 1 đáp án", desc: "Thí sinh chọn đúng 1 phương án.", color: "#007bff" },
  { code: "multiple", name: "Trắc nghiệm nhiều đáp án", desc: "Thí sinh chọn nhiều phương án; đúng khi khớp toàn bộ.", color: "#17a2b8" },
  { code: "sort", name: "Sắp xếp vị trí", desc: "Thí sinh sắp các mục theo đúng thứ tự (hệ thống tự xáo trộn khi hiển thị).", color: "#f0a500" },
  { code: "match", name: "Nối cột", desc: "Nối mỗi mục cột trái với mục cột phải tương ứng.", color: "#6f42c1" },
  { code: "essay", name: "Tự luận", desc: "Thí sinh tự viết; giáo viên chấm tay sau khi nộp.", color: "#28a745" },
];

const quyTrinh = [
  {
    id: "a1",
    title: "Bước 1: Tạo câu hỏi vào Ngân hàng câu hỏi",
    intro: "Ngân hàng câu hỏi dùng chung cho mọi đề. Tạo câu hỏi ở đây trước, sau đó gắn vào các bài kiểm tra.",
    links: [{ label: "Ngân hàng câu hỏi", to: "/learninghub_cauhoi" }],
    steps: [
      "Vào menu Learning Hub > Ngân hàng câu hỏi.",
      "Bấm nút Thêm mới (①) ở góc phải để tạo câu hỏi, hoặc dùng ô Tìm kiếm (②) để lọc câu đã có.",
    ],
    image: "/huong-dan-learning-admin/01-ngan-hang-cau-hoi.png",
    caption: "Màn hình Ngân hàng câu hỏi: ① nút Thêm mới, ② bộ lọc tìm kiếm theo nội dung/loại.",
  },
  {
    id: "a2",
    title: "Bước 2: Nhập nội dung câu hỏi",
    intro: "Chọn dạng câu hỏi phù hợp và nhập nội dung + đáp án.",
    links: [{ label: "Tạo câu hỏi", to: "/add-learninghub_cauhoi" }],
    steps: [
      "Chọn Loại câu hỏi (①): trắc nghiệm 1/nhiều đáp án, sắp xếp, nối cột hoặc tự luận.",
      "Chọn Danh mục câu hỏi để phân loại; bấm Quản lý danh mục (②) để thêm/sửa danh mục (có thể tạo danh mục cha - con).",
      "Nhập Nội dung câu hỏi (③) bằng trình soạn thảo.",
      "Nhập các lựa chọn và đánh dấu đáp án đúng (với dạng trắc nghiệm/sắp xếp/nối cột).",
      "Bấm Xem trước (④) để xem đúng giao diện học sinh sẽ thấy.",
      "Bấm Lưu lại (⑤).",
    ],
    image: "/huong-dan-learning-admin/02-tao-cau-hoi.png",
    caption: "Màn tạo câu hỏi: ① Loại câu hỏi, ② Quản lý danh mục, ③ Nội dung, ④ Xem trước, ⑤ Lưu lại.",
  },
  {
    id: "a3",
    title: "Bước 3: Quản lý danh mục câu hỏi",
    intro: "Danh mục giúp lọc câu hỏi nhanh khi tạo đề. Hỗ trợ nhiều cấp cha - con.",
    links: [],
    steps: [
      "Trong form câu hỏi, bấm Quản lý danh mục.",
      "Nhập Tên danh mục (①).",
      "Chọn Danh mục cha (②) nếu muốn tạo danh mục con; để trống nếu là danh mục gốc.",
      "Bấm Thêm (③). Có thể Sửa / Xoá danh mục trong danh sách bên dưới.",
    ],
    image: "/huong-dan-learning-admin/03-quan-ly-danh-muc.png",
    caption: "Cửa sổ quản lý danh mục: ① Tên danh mục, ② Danh mục cha, ③ nút Thêm.",
  },
  {
    id: "a4",
    title: "Bước 4: Xem trước câu hỏi (giao diện học sinh)",
    intro: "Kiểm tra câu hỏi hiển thị đúng như học sinh sẽ thấy trước khi lưu.",
    links: [],
    steps: [
      "Sau khi nhập nội dung, bấm nút Xem trước (giao diện học sinh).",
      "Cửa sổ hiện ra mô phỏng đúng cách học sinh làm câu hỏi này. Đáp án đúng được ẩn đi (giống lúc học sinh làm thật).",
    ],
    image: "/huong-dan-learning-admin/04-xem-truoc-cau-hoi.png",
    caption: "Cửa sổ Xem trước hiển thị câu hỏi đúng như giao diện học sinh làm bài.",
  },
  {
    id: "a5",
    title: "Bước 5: Tạo Bài kiểm tra / Bài tập",
    intro: "Sau khi có câu hỏi, tạo đề và gắn câu hỏi vào.",
    links: [{ label: "Danh sách đề", to: "/learninghub_dethi" }, { label: "Tạo đề", to: "/add-learninghub_dethi" }],
    steps: [
      "Vào menu Learning Hub > Bài kiểm tra / Bài tập, bấm Thêm mới.",
      "Nhập Tiêu đề, chọn Loại (bài kiểm tra / bài tập về nhà), Thời gian làm (phút).",
      "Bấm Lưu thông tin đề để tạo đề trước, sau đó mới thêm được câu hỏi.",
    ],
    image: "/huong-dan-learning-admin/05-danh-sach-de.png",
    caption: "Danh sách Bài kiểm tra / Bài tập: ① nút Thêm mới.",
  },
  {
    id: "a6",
    title: "Bước 6: Cấu hình đề, người tham gia và cách tính điểm",
    intro: "Trong màn sửa đề, thiết lập đối tượng làm bài, cách chấm điểm và danh sách câu hỏi.",
    links: [{ label: "Danh sách đề", to: "/learninghub_dethi" }],
    steps: [
      "Người tham gia (①): để trống = tất cả đều làm được; chọn nhân sự và/hoặc phòng ban để giới hạn đối tượng.",
      "Cách tính điểm (②): Tổng điểm chia đều cho các câu, hoặc Nhập điểm thủ công từng câu.",
      "Bấm Thêm câu hỏi từ ngân hàng (③) để chọn câu hỏi cho đề.",
      "Bấm Làm thử đề (④) để tự trải nghiệm đề như học sinh (không lưu, không chấm).",
      "Bấm Theo dõi realtime (⑤) để giám sát học sinh đang làm bài.",
    ],
    image: "/huong-dan-learning-admin/06-tao-de.png",
    caption: "Màn cấu hình đề: ① Người tham gia, ② Cách tính điểm, ③ Thêm câu hỏi, ④ Làm thử đề, ⑤ Theo dõi realtime.",
    note: "Điểm từng câu và thứ tự có thể chỉnh trực tiếp trong bảng Câu hỏi trong đề ở phía dưới.",
  },
  {
    id: "a7",
    title: "Bước 7: Chọn câu hỏi từ ngân hàng (chọn nhiều)",
    intro: "Thêm nhiều câu hỏi cùng lúc, tránh chọn từng câu.",
    links: [],
    steps: [
      "Bấm Thêm câu hỏi từ ngân hàng.",
      "Lọc theo Danh mục (①) hoặc Tìm theo nội dung (②).",
      "Tích chọn nhiều câu hỏi cần thêm (câu đã có trong đề sẽ tự ẩn để tránh trùng).",
      "Bấm Thêm N câu (③) để đưa tất cả vào đề.",
    ],
    image: "/huong-dan-learning-admin/07-chon-cau-hoi.png",
    caption: "Cửa sổ chọn câu hỏi: ① lọc danh mục, ② tìm theo nội dung, ③ nút Thêm các câu đã chọn.",
  },
  {
    id: "a8",
    title: "Bước 8: Theo dõi học sinh làm bài (realtime)",
    intro: "Giám sát trực tiếp học sinh đang làm bài, thấy đáp án các em đang chọn theo thời gian thực.",
    links: [],
    steps: [
      "Trong màn sửa đề, bấm Theo dõi realtime.",
      "Danh sách học sinh đang làm / đã nộp hiển thị kèm tiến độ; badge kết nối (①) cho biết đang nhận dữ liệu.",
      "Bấm vào từng học sinh để xem chi tiết đáp án các em đang chọn (cập nhật ngay khi học sinh thao tác).",
    ],
    image: "/huong-dan-learning-admin/10-theo-doi-realtime.png",
    caption: "Màn theo dõi realtime: ① trạng thái kết nối. Bấm từng học sinh để xem đáp án đang chọn.",
  },
  {
    id: "a9",
    title: "Bước 9: Xem và chấm bài làm của thí sinh",
    intro: "Sau khi học sinh nộp, xem kết quả và chấm điểm câu tự luận.",
    links: [{ label: "Bài làm của thí sinh", to: "/learninghub_bailam" }],
    steps: [
      "Vào menu Learning Hub > Bài làm của thí sinh.",
      "Bài có câu tự luận sẽ ở trạng thái Chờ chấm — bấm Chấm bài (①); bài đã xong bấm Xem (②).",
      "Phần trắc nghiệm được hệ thống chấm tự động (hiển thị Đúng/Sai, đáp án đúng tô xanh).",
      "Với câu tự luận: đọc bài làm, nhập điểm và nhận xét, rồi bấm Lưu điểm & chốt bài.",
    ],
    image: "/huong-dan-learning-admin/08-danh-sach-bai-lam.png",
    caption: "Danh sách bài làm: ① Chấm bài (bài chờ chấm), ② Xem (bài đã xong).",
  },
  {
    id: "a10",
    title: "Bước 10: Màn chấm điểm chi tiết",
    intro: "Xem toàn bộ đáp án của học sinh, thời gian làm và điểm từng phần.",
    links: [],
    steps: [
      "Đầu trang hiển thị Thí sinh, Thời gian làm, điểm khách quan, điểm tự luận và Tổng.",
      "Mỗi câu hiển thị đáp án học sinh chọn; câu đúng/sai được tô màu, đáp án đúng đánh dấu ✔.",
      "Nhập điểm cho câu tự luận (nếu có) rồi chốt bài.",
    ],
    image: "/huong-dan-learning-admin/09-cham-bai.png",
    caption: "Màn chấm bài: thông tin thí sinh, thời gian làm, điểm từng phần và đối chiếu đáp án từng câu.",
  },
];

export default function HuongDanLearningAdmin() {
  const [open, setOpen] = useState("a1");
  const toggle = (id) => setOpen(open === id ? "" : id);

  return (
    <AkkhorLayout idrole="learninghub_dethi">
      <div className="breadcrumbs-area">
        <ul>
          <li><Link to="/">Trang chủ</Link></li>
          <li>Hướng dẫn giảng viên</li>
        </ul>
      </div>

      <div className="card height-auto mb-3">
        <div className="card-body">
          <div className="heading-layout1">
            <div className="item-title">
              <h3 className="mb-0">
                <span className="fas fa-chalkboard-teacher mr-2" style={{ color: "#f0a500" }} />
                Hướng dẫn giảng viên
              </h3>
            </div>
          </div>
          <p className="mb-2">
            Tài liệu hướng dẫn tạo <b>câu hỏi</b>, <b>bài kiểm tra / bài tập</b>, giao bài cho học sinh,
            theo dõi làm bài trực tuyến và chấm điểm trong module <b>LearningHub</b>.
          </p>
          <p className="mb-0" style={{ color: "#888" }}>
            Các chức năng nằm trong menu <b>Learning Hub</b>.
          </p>
        </div>
      </div>

      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3"><span className="fas fa-th-large mr-2" style={{ color: "#17a2b8" }} />1. Chức năng chính</h4>
          <div className="row">
            {chucNang.map((c, i) => (
              <div className="col-12 col-md-6 col-lg-4 mb-3" key={i}>
                <div style={{ border: "1px solid #eee", borderRadius: 8, padding: "12px 14px", height: "100%" }}>
                  <Link to={c.link} style={{ fontWeight: 600, fontSize: 15 }}>
                    <span className="fas fa-arrow-circle-right mr-1" />{c.group}
                  </Link>
                  <div style={{ color: "#777", fontSize: 13, marginTop: 6 }}>{c.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3"><span className="fas fa-shapes mr-2" style={{ color: "#6f42c1" }} />2. Các dạng câu hỏi</h4>
          <div className="row">
            {loaiCauHoi.map((s) => (
              <div className="col-12 col-md-6 col-lg-4 mb-3" key={s.code}>
                <div style={{ borderLeft: `4px solid ${s.color}`, background: "#fafafa", borderRadius: 6, padding: "10px 12px", height: "100%" }}>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>{s.name}</div>
                  <div style={{ fontSize: 12.5, color: "#777" }}>{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3"><span className="fas fa-list-ol mr-2" style={{ color: "#6f42c1" }} />3. Các bước thực hiện</h4>
          {quyTrinh.map((qt) => {
            const isOpen = open === qt.id;
            return (
              <div key={qt.id} style={{ border: "1px solid #eee", borderRadius: 8, marginBottom: 10, overflow: "hidden" }}>
                <div onClick={() => toggle(qt.id)} style={{ cursor: "pointer", padding: "12px 15px", background: isOpen ? "#f0f4ff" : "#f7f7f7", display: "flex", alignItems: "center", fontWeight: 600 }}>
                  <span className={isOpen ? "fas fa-chevron-down mr-2" : "fas fa-chevron-right mr-2"} style={{ color: "#6f42c1", fontSize: 13 }} />
                  {qt.title}
                </div>
                {isOpen && (
                  <div style={{ padding: "14px 18px" }}>
                    <p style={{ color: "#666", fontSize: 13.5 }}>{qt.intro}</p>
                    {qt.links && qt.links.length > 0 && (
                      <div style={{ marginBottom: 10 }}>
                        {qt.links.map((l, i) => (
                          <Link key={i} to={l.to} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark mr-2" style={{ fontSize: 12.5 }}>
                            <span className="fas fa-external-link-alt mr-1" />{l.label}
                          </Link>
                        ))}
                      </div>
                    )}
                    <ol style={{ paddingLeft: 18, fontSize: 13.5, lineHeight: 1.7 }}>
                      {qt.steps.map((s, i) => <li key={i}>{s}</li>)}
                    </ol>
                    {qt.image && (
                      <figure style={{ margin: "12px 0 4px" }}>
                        <a href={qt.image} target="_blank" rel="noopener noreferrer">
                          <img src={qt.image} alt={qt.caption || qt.title} style={{ width: "100%", maxWidth: 1000, border: "1px solid #e3e3e3", borderRadius: 8, boxShadow: "0 2px 8px rgba(0,0,0,.08)", display: "block" }} />
                        </a>
                        {qt.caption && (
                          <figcaption style={{ fontSize: 12.5, color: "#888", marginTop: 6, fontStyle: "italic" }}>
                            <span className="fas fa-camera mr-1" />{qt.caption} (Bấm ảnh để xem lớn.)
                          </figcaption>
                        )}
                      </figure>
                    )}
                    {qt.note && (
                      <div style={{ background: "#fff8e1", border: "1px solid #ffe0a3", borderRadius: 6, padding: "8px 12px", fontSize: 12.5, color: "#8a6d00", marginTop: 8 }}>
                        <span className="fas fa-lightbulb mr-1" />{qt.note}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </AkkhorLayout>
  );
}
